module.exports = __webpack_public_path__ + "static/media/main_menu_icon.eb811048.svg";